import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0615f20a&"
var script = {}


/* normalize component */
import normalizer from "!/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports